<template>
    <PreLoginView>
        <PreLoginForm @go-home="goBack" title="LABEL_SET_NEW_PASSWORD">
            <LoginTextInput
                @visiblityToggled="toggleVisiblity"
                :errors="errors"
                :label="$t('LABEL_NEW_PASS')"
                placeholder="*******"
                autocomplete="new-password"
                name="password"
                ref="password"
                type="password"
                :passwordStrength="true"
                v-model.trim="password"
            />
            <LoginTextInput
                @visiblityToggled="toggleVisiblity"
                :errors="errors"
                :label="$t('PLACEHOLDER_PASSWORD_CONFIRM')"
                placeholder="*******"
                autocomplete="new-password"
                ref="repeatPassword"
                name="confirmPassword"
                type="password"
                v-model.trim="confirmPassword"
            />
            <PreLoginButton
                :label="$t('LABEL_RESET_PASSWORD_ACTION')"
                style="margin-top: 2rem"
                :loading="loading"
                @click="submit"
            />
        </PreLoginForm>
        <div class="login-actions-row">
            <TextButton label="BUTTON_BACK" @click="goBack" />
        </div>
    </PreLoginView>
</template>
<script>
import { regionOptions } from '@/helpers/Language'
import LoginTextInput from '@/views/PreLoginView/LoginTextInput.vue'
import LoginSelectInput from '@/views/PreLoginView/LoginSelectInput.vue'
import PreLoginView from '@/views/PreLoginView/PreLoginView'
export default {
    components: {
        PreLoginForm: () => import('@/views/PreLoginView/PreLoginForm'),
        PreLoginButton: () => import('@/views/PreLoginView/PreLoginButton'),
        PreLoginView,
        LoginTextInput
    },
    data() {
        return {
            loading: false,
            errors: new this.$Errors(),
            password: '',
            confirmPassword: '',
            regionOptions
        }
    },
    methods: {
        async handleQuery() {
            const searchParams = new URLSearchParams(window.location.search)
            if (searchParams.get('region'))
                this.setRegion(searchParams.get('region'))
        },
        goBack() {
            window.location = this.$env.getMainApp()
        },
        setRegion(region) {
            this.$store.commit('setRegion', region)
        },
        toggleVisiblity(visibility) {
            this.$refs.password.passwordVisible = visibility
            this.$refs.repeatPassword.passwordVisible = visibility
        },
        submit() {
            if (this.loading) {
                return
            }
            if (!this.password) {
                this.errors.set('password')
                return
            }
            if (!this.confirmPassword) {
                this.errors.set('confirmPassword')
                return
            }
            if (this.password != this.confirmPassword) {
                this.errors.set('password')
                this.errors.set('confirmPassword')
                this.$Notif.error('TOAST_PASSWORD_MATCH')
                return
            }
            this.loading = true
            this.$api
                .post('v2/reset/confirm', {
                    token: this.$route.params.token,
                    password: this.password
                })
                .then(() => {
                    this.loading = false
                    this.$router.push('/status/reset_password_success')
                })
                .catch(() => {
                    this.$router.push('/status/reset_password_failure')
                    this.loading = false
                })
        }
    },
    mounted() {
        this.handleQuery()
    }
}
</script>
